import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { withAppContext, AppContextType } from '../../context/AppContext';
import { PageContextType } from '../../types';
import { slicesTypesMapping } from './enums';
import { Slice, SliceContext } from './types';

type SlicesProps = {
    location: Location;
    pageContext: PageContextType;
    slices: Slice[];
    context: AppContextType;
};

class SlicesComponent extends React.Component<SlicesProps> {
    onVisibilityChange = (isVisible: boolean, sliceContext: SliceContext) => {
        const segment = this.props.context.segment;
        // Send "Slice Viewed" event to segment
        if (isVisible && segment) {
            segment.trackSliceViewed(sliceContext);
        }
    };

    render() {
        const { location, pageContext, slices } = this.props;

        if (!slices) {
            return null;
        }

        return slices.map((slice: Slice, index: any) => {
            const SliceComponent = slicesTypesMapping[slice.slice_type];
            const sliceContext: SliceContext = {
                position: index,
                type: slice.slice_type,
            };
            return (
                SliceComponent && (
                    <VisibilitySensor
                        key={index}
                        onChange={isVisible => this.onVisibilityChange(isVisible, sliceContext)}
                        partialVisibility={true}
                        delayedCall={true}
                    >
                        <SliceComponent
                            location={location}
                            pageContext={pageContext}
                            sliceContext={sliceContext}
                            slice={slice}
                        />
                    </VisibilitySensor>
                )
            );
        });
    }
}

const Slices = withAppContext(SlicesComponent);

export { Slices, SlicesComponent, SlicesProps };
